export default function ({commit}, {field, value}) {
    let data = {};
    switch (field){
        default:
            data[field] = value;
    }
    commit('set', data);
}